import type { Resource } from '../../';
export const order_orderHistory_title: Resource = {"default":"Order History"};
